import { useNavigate } from "react-router-dom";
import { PayBillAmountModalProps } from "../../../../interfaces/order-management-props.interface";

const PayBillAmountModal = ({
  paidAmount,
  actualAmount,
  showBillAmountModal,
  fromOrderCreate,
  onClose,
  getActiveCustomerOrders,
}: PayBillAmountModalProps) => {

  const paid = Number(paidAmount || 0);
  const actual = Number(actualAmount || 0);
  const diff = Math.round((paid - actual) * 100) / 100;
  const displayChange = Math.abs(diff) < 0.01 ? 0 : diff; 

  const navigate = useNavigate();

  const handleContinueClick = () => {
    if (fromOrderCreate) {
      navigate("/");
    } else {
      showBillAmountModal();
    }
    onClose();
    getActiveCustomerOrders?.();
  };

  return (
    <div
      className="relative z-[9999]"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        className="fixed inset-0 bg-[#000000] bg-opacity-60 transition-opacity"
        aria-hidden="true"
      ></div>

      <div className="fixed inset-0 z-[9999] overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div className="w-[381px] relative transform overflow-hidden rounded-2xl bg-white text-left shadow-xl transition-all sm:my-8">
            <div className="flex items-center justify-center bg-gray-100 flex-col">
              <div className="bg-white flex flex-col items-center px-8 py-4">
                <div>
                  <h1 className="text-xl font-medium mt-3">Payment Detail</h1>
                </div>
                <div className="mt-4">
                  <h1 className="text-xl text-center text-[#16bc16] mt-6">
                    Change : ${displayChange.toFixed(2)}
                  </h1>
                  <h1 className="text-sm text-center mt-2">
                    Cash Paid : ${paidAmount?.toFixed(2)}
                  </h1>
                </div>
                <div className="flex gap-3 mt-4">
                  <div className="flex justify-center my-4">
                    <button
                      className="w-[100%] px-8 text-xs flex justify-center items-center gap-2 text-white h-[34px] rounded-xl bg-orange hover:bg-white hover:text-orange duration-500"
                      onClick={handleContinueClick}
                    >
                      Continue
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayBillAmountModal;

